/**
 * @module app.core
 */

import * as Core from 'app/core/models/essette-api';

export class InitialsValueConverter {

    /**
     * Get's a person's initials from their full name
     *
     * @param value `Core.PersonName` or `string`
     */
    public toView(value: unknown): string | null {
        if(value === null || value === undefined) {
            return null;
        }

        let fullName: string | null = null;
        if(typeof value === 'object') {
            const name: Core.PersonName = <Core.PersonName>value;
            fullName = name.full || null;
        }
        else if(typeof value === 'string') {
            fullName = value;
        }

        if(fullName) {
            // regex patthen from: https://stackoverflow.com/questions/33076177/getting-name-initials-using-js
            const matches = fullName.match(/\b(\w)/g);
            if(matches) {
                return matches.join('');
            }
        }

        return null;
    }

}
